<div class="row mb-3">
    <div class="col-md-12">
        <span style="font-weight:bolder;">Documents section</span><br>
        <span>All documents marked with "*" must be uploaded in order for request to be
            submitted. Documents without asterisk (*) are optional.</span><br>
        <span>Number of Mandatory documents to be uploaded - <b>{{pendingCount}}</b></span><br>
    </div>
</div>
<form name="form" class="needs-validation" #f="ngForm" novalidate>
    <fieldset [disabled]="readonly">
        <div class="row brd-b">
            <div class="col-md-12">
                <div style="margin-bottom: 2px;">
                    <button [ngStyle]="{'background-color': allDoc ?'#D7D7D7':'transparent'}"
                        class="btn btn-outline-primary me-2" (click)="getfileGrid(1)">All <span class="oval"
                            style="background-color: #282836;">{{totalCount}}</span></button>
                    <button [ngStyle]="{'background-color': uploadedDoc ?'#D7D7D7':'transparent'}"
                        class="btn btn-outline-primary me-2" (click)="getfileGrid(2)">Uploaded <span class="oval"
                            style="background-color: #168736;">{{uploadedCount}}</span></button>
                    <button [ngStyle]="{'background-color': pendingDoc ?'#D7D7D7':'transparent'}"
                        class="btn btn-outline-primary me-2" (click)="getfileGrid(3)">Upload pending <span class="oval"
                            style="background-color: #F76900;">{{pendingAllCount}}</span></button>
                    <div class="float-end form-check">
                        <input type="checkbox" class="form-check-input" id="mandatoryCheckbox"
                            (click)="mandatoryCheck()">
                        <label class="form-check-label" for="mandatoryCheckbox">Filter mandatory documents</label>
                    </div>
                    <!-- <button *ngIf="!isAdditionalUpload && isSearch && !readonly && !immUserProfileView"
                            class="btn btn-outline-primary me-2 float-end" eosDebounce
                            (debounceClick)="AdditionalDocReq()"><img style="height:19px;padding-bottom:4px;"
                                src="design/images/doc-search-alt.svg"> Request additional documents</button> -->
                    <button class="btn btn-outline-primary me-2 float-end" eosDebounce
                        (debounceClick)="downloadAll()"><img *ngIf="!showSpinner"
                            style="height:19px;padding-bottom:4px;" src="design/images/download.svg"> Download
                        All</button>
                    <span *ngIf="showSpinner" class="spinner m-3 down_img doc-spin"></span>
                </div>
                <div class="table-resp table-responsive document-view-scroll mb-3">
                    <table class="table table-bordered">
                        <tr class="stick-on-top">
                            <th style="width:30%;">Type of document</th>
                            <th style="width:30%;">CM9 Document name</th>

                            <th style="width:20%;">Description</th>
                            <th style="width:8%;">Date</th>
                            <th style="width:15%;"></th>
                        </tr>

                        <tr *ngIf="gridFiles.length==0">
                            <td> No documents </td>
                        </tr>
                        <tr *ngFor="let doc of gridFiles; let i = index;" style="height: 20px !important">

                            <td>{{doc.documentTypeName+' '+ (doc.mandatoryType == 1 ?'*':'')}}</td>
                            <td style="padding:0"><div class="dot"
                                    [ngStyle]="{'background-color': doc.isUploaded ?'#168736':'#F76900'}"></div>
                                {{getDocNameForGrid(doc)+' '+ (doc.mandatoryType == 1 ?'*':'')}}</td>

                            <td>
                                <input name="doc.{{i}}.desc" style="height: 25px" type="text"
                                    class="form-control form-control-sm custom-bordered-input" [(ngModel)]="doc.description">
                            </td>
                            <td *ngIf="doc.modifiedDate == null" style="padding: 0;">{{doc.createdDate | localDate:
                                'dd-MM-yyyy'}}</td>
                            <td *ngIf="doc.modifiedDate != null" style="padding: 0;">{{doc.modifiedDate | localDate:
                                'dd-MM-yyyy'}}</td>
                            <td *ngIf="!doc.isUploaded || doc.isEditMode">

                                <div>
                                    <input [disabled]="disableUpload" #fileControl name="fileName" type="file"
                                        (change)="fileSelected($event.target.files)" #fileName
                                        [accept]="fileBrowserAllowedTypes" style="display: none;">

                                    <input #fileField type="text" readonly [value]="selectedFileName"
                                        style="display: none;"
                                        [ngClass]="{ 'is-invalid': (fileName.dirty || fileName.touched || f.submitted) && !selectedDocument && !doc.isEditMode || ifDocNotValid }"
                                        required />

                                    <div style="text-align: right;">
                                        <!-- <img src="design/images/info.png" placement="left"
                                                ngbTooltip={{doc.instruction}} tooltipClass="delegate-tooltip" /> -->
                    
                                        <button type="button" *ngIf="doc.isEditMode" (click)="closeEdit(doc)" class="btn-close" aria-label="Close" title="Close Edit"></button>

                                        <img class="cursor" src="design/images/attachment_1.svg"
                                            (click)="browseFile(doc)" ngbTooltip={{doc.instruction}}
                                            tooltipClass="delegate-tooltip" placement="left" />
                                    </div>
                                </div>
                            </td>
                            <td *ngIf="doc.isUploaded && !doc.isEditMode">
                                <div>
                                    <div style="text-align: right;">
                                        <a (click)="preview(doc)">
                                            <img class="cursor" src="design/images/eye-alt.svg" />
                                        </a>
                                        <a *ngIf="!readonly  && isEditable(doc)" (click)="edit(doc,i)">
                                            <img class="cursor" src="design/images/edit-pencil.svg" />
                                        </a>
                                        <a (click)="downloadDocument(doc)">
                                            <img class="cursor" src="design/images/download.svg"
                                                title="{{doc.fileName}}">
                                        </a>
                                        <a *ngIf="!readonly && isEditable(doc)" (click)="delete(doc)"><img
                                                class="cursor" src="design/images/trash.svg" /></a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </fieldset>
</form>